import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  hoverable = true, 
  selected = false,
  onClick 
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        bg-white rounded-xl shadow-md border transition-all duration-300 overflow-hidden
        ${hoverable ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer' : ''}
        ${selected ? 'ring-2 ring-blue-500 border-blue-300 bg-blue-50/30' : 'border-gray-200'}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;